import styled from "styled-components";

export const InputContainer = styled.div`
  width: 100%;

  textarea {
    background-color: #fff;

    ::placeholder {
      color: rgba(17, 37, 47, 0.36);
    }
  }
`;
